import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PublicTestimonial {
  id: string;
  quote: string;
  author_name: string;
  author_title: string | null;
  rating: number | null;
  sort_order: number;
}

/**
 * Public read of active testimonials for the conversion flow (#256). Anon-safe —
 * RLS exposes `is_active` rows (see src/test/integration/public-reads.test.ts).
 * Separate from `useTestimonialsAdmin` (which selects every row for the editor).
 */
export function useTestimonials() {
  return useQuery({
    queryKey: ["testimonials-public"],
    queryFn: async (): Promise<PublicTestimonial[]> => {
      const { data, error } = await supabase
        .from("testimonials")
        .select("id, quote, author_name, author_title, rating, sort_order")
        .eq("is_active", true)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 10 * 60 * 1000,
  });
}
